import { z } from "zod";

import { AmplitudeEventIds } from "../constants";

import { amplitudeEvent } from "./base";

export const OrdersPageAdPlatformSelectEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.ORDERS_PAGE_SELECT_PLATFORM,
    camelCaseName: "ordersPageAdPlatformSelectEvent",
    label: "Orders page select platform",
  },
  {
    platforms: z.array(z.string()),
  },
);

export const OrdersPageOrderIdEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.ORDERS_PAGE_ORDER_ID,
    camelCaseName: "ordersPageOrderIdEvent",
    label: "Orders page click order id",
  },
  {
    orderId: z.string(),
  },
);

export const ORDERS_PAGE_EVENTS = [
  OrdersPageAdPlatformSelectEvent,
  OrdersPageOrderIdEvent,
] as const;
